import React, { useMemo } from "react";
import { format } from "date-fns";
import { formatCurrency } from "../../../utils/formatCurrency";
import { formatDate } from "../../../utils/formatDate";
import { useAppContext } from "../../../context/AppContext";


const TableSalesSummary = ({ table }) => {
  const { nomenclatures, permissions } = useAppContext();
  const nomenclature = useMemo(() => {
    try {
      return JSON.parse(nomenclatures);
    } catch {
      return [
        { value: 'Quadra' },
        { value: 'Lote' }
      ];
    }
  }, [nomenclatures]);

  if (!table) return null;

  const columns = [
    `${nomenclature[0]?.value || 'Quadra'} / ${nomenclature[1]?.value || 'Lote'}`,
    "Data da Venda",
    "Cliente",
    "Valor da Venda",
    "Valor Financiado",
    "Recebido",
    "Inadimplência",
    "A Receber"
  ];

  return (
    <div className="my-3 d-flex justify-content-center text-center overflow-hidden">
  
      <table style={{ width: "99%" }} >
        <tbody>
          <tr
            className="fw-bolder"
            style={{ backgroundColor: "#b8b8b8", color: "#2D2D2D" }}
          >
            {columns.map((item, i) => (
              <td
                key={i}
                className="border border-white border-1 p-1 text-center"
                style={{ maxWidth: "72px", overflow: "hidden", textOverflow: "ellipsis", }}
              >
                {item}
              </td>
            ))}
          </tr>
          {table.data && table.data.length > 0 ? (
            table.data.map((item, idx) => (
              <tr key={idx} >
                <td className="text-center border" >{item.block_unit}</td>
                <td className="text-center border" >{formatDate(item.sale_data)}</td>
                <td className="text-center border" >{item.client?.name}</td>
                <td className="text-center border" >{formatCurrency(item.sale_value)}</td>
                <td className="text-center border" >{formatCurrency(item.financial_value)}</td>
                <td className="text-center border" >{formatCurrency(item.received)}</td>
                <td className="text-center border" >{formatCurrency(item.overdue)}</td>
                <td className="text-center border" >{formatCurrency(item.to_receive)}</td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan={columns.length} className="text-center">Nenhum dado encontrado.</td>
            </tr>
          )}
          <tr className="fw-bolder" style={{ fontSize: "11px", translate: "0px 5px" }}>
            <td colSpan={3}>Totais</td>
            <td>{formatCurrency(table.totais?.sale_value)}</td>
            <td>{formatCurrency(table.totais?.financial_value)}</td>
            <td>{formatCurrency(table.totais?.received)}</td>
            <td>{formatCurrency(table.totais?.debtor)}</td>
            <td>{formatCurrency(table.totais?.to_receive)}</td>
          </tr>
          <tr className="fw-bolder" style={{ fontSize: "11px", translate: "0px 2px" }}>
            <td colSpan={columns.length}>Total de Registros: {table.data?.length || 0}</td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default TableSalesSummary;
